var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.099 51.1518C29.9988 50.0502 29.3809 48.557 29.3809 47.0001C29.3809 45.4432 29.9988 43.95 31.099 42.8484L53.2517 20.6879C54.3538 19.5863 55.8484 18.9677 57.4067 18.968C58.1783 18.9682 58.9423 19.1204 59.655 19.4158C60.3678 19.7112 61.0154 20.1442 61.5609 20.6899C62.1064 21.2356 62.539 21.8834 62.8341 22.5963C63.1292 23.3093 63.281 24.0733 63.2808 24.8449C63.2806 25.6165 63.1285 26.3805 62.833 27.0932C62.5376 27.806 62.1047 28.4536 61.5589 28.9991L43.5619 47.0001L61.5629 65.0011C62.1242 65.5428 62.5721 66.1909 62.8803 66.9075C63.1886 67.6241 63.351 68.3949 63.3581 69.175C63.3653 69.9551 63.217 70.7288 62.9219 71.4509C62.6269 72.1731 62.191 72.8292 61.6396 73.3811C61.0882 73.933 60.4325 74.3695 59.7106 74.6653C58.9887 74.961 58.2152 75.11 57.4351 75.1036C56.655 75.0972 55.8841 74.9355 55.1671 74.6279C54.4502 74.3204 53.8017 73.8731 53.2595 73.3123L31.0912 51.1518H31.099Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSelect);
export default __webpack_public_path__ + "static/media/leftSelect.86399d971484246c137c007e962eed3a.svg";
export { ForwardRef as ReactComponent };